module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_pp3_9016.647d9ccf.png";